import _html_helper from './_html_helper'

export default function Offcanvas(opts){

  if(!opts.id){
    throw("Necessita de id") //kkkkkkkkkk
  }

  let element_id = opts.id
  let element = undefined
  let translateX = '305'
  let options = opts

  this.generate = function(){
    let context = this
    let html = '<div class="card offcanvas '+ (opts.width || "offcanvas-wmd") + ' ' + (opts.height || "offcanvas-hmd") +' '+(options.position || 'left')+' box-shadow-sm card-hover" id="'+options.id+'">'+
              '<div class="offcanvas-body pretty-scrollbar"><div class="titles">';
    html+= (options.title) ? _html_helper.generateTitle(options.title, options.subtitle) + "</div>" : "</div>"
    html += _html_helper.generateCloseButton()
    html += '<div class="card-body"><div class="content hideable"></div></div>'+
            '</div>'+
          '</div>'
    $(document.body).append(
      html
    )

    element = $("#"+element_id)
    
    //adicioanndo ação de fechar no botão do offcanvas
    element.find('button.close').on('click', function(){
      context.hide()
    })
  }
  this.show = function(){
    element.addClass('show')
  }
  this.hide = function(){
    element.removeClass('show')
    element.trigger('hidden')
  },
  this.updateTitles = (title, subtitle)=>{
    $(element).find('.titles').html(_html_helper.generateTitle(title, subtitle))
  }

  this.hideContent = (selector) =>{
    element.find(selector).addClass('hide')
  }

  this.showContent = (selector) =>{
    element.find(selector).removeClass('hide')
  }

  this.toggle= function(){
    if(element.hasClass("show")){
      this.hide();
    } else {
      this.show();
    }
  }
  this.appendToBody = function(html, container='.content'){
    element.find(container).append(html)
  }
  //adiciona uma div no mesmo nivel do wrapper '.content'. Importante em situações onde se deseja esconder/mostrar conteudo no mesmo offcanvas
  this.appendContent = function(klass){
    element.find('.card-body').append('<div class="'+klass+' hideable"></div>')
  }
  this.elementIsHidden= function(){
    return !element.hasClass("show")
  }
}
window.OffcanvasMenu = OffcanvasMenu